import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const Hero = () => {
  const { currentTheme } = useTheme();
  
  return (
    <section className={`bg-gradient-to-br ${currentTheme.colors.primary} text-white overflow-hidden relative min-h-screen md:h-screen`}>
      <h1 className="sr-only">
        Independent Music Composer & Music Educator – Mukesh Rathore
      </h1>
      {/* Soft glow effect */}
      <div className={`absolute inset-0 bg-gradient-to-r ${currentTheme.colors.secondary.replace('from-', 'from-').replace('to-', 'to-')}/20 blur-3xl`}></div>
      
      <div className="w-full h-full px-6 md:px-12 lg:px-20 relative z-20 pb-8 md:pb-0">
        <div className="grid md:grid-cols-3 gap-8 items-center h-full pt-8 md:pt-12">
          {/* Left side - Text content */}
          <div className="text-left md:col-span-2 lg:col-span-2 relative z-30">
            <motion.h1 
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-6 leading-tight"
            >
          
              Join the <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-300 to-blue-300">
                Indie Music Creators<br /> Movement
              </span>
            </motion.h1>
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex flex-col sm:flex-row gap-1 justify-left mb-8"
            >
              <motion.button 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.open('https://indiemusiccreators.com/', '_blank')}
                className="bg-orange-600 hover:bg-orange-700 text-white font-bold py-4 px-8 md:py-8 md:px-24 rounded-lg text-xl md:text-3xl transition-all shadow-2xl"
              >
              Watch How It Works
              </motion.button>
              
            </motion.div>
            <motion.p 
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-lg md:text-xl lg:text-2xl mb-10 text-gray-200 leading-relaxed max-w-2xl text-left"
            >
              A structured ecosystem designed by Mukesh Rathore—<br />
              to help singers turn their musical ideas into released original songs—step by step within 90 days.
            </motion.p>
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="inline-flex flex-wrap items-center gap-4 md:gap-6 mb-8 md:mb-8 bg-white/10 backdrop-blur-md rounded-full px-4 md:px-6 py-3 border border-white/20 shadow-xl"
            >
              
              
              <div className="flex items-center gap-2">
                <span className="text-xl md:text-2xl">🎵</span>
                <span className="text-sm md:text-base lg:text-lg font-bold text-white">
                  45+ original songs released
                </span>
              </div>
              <div className="w-px h-6 bg-white/30"></div>
              <div className="flex items-center gap-2">
                <span className="text-xl md:text-2xl">📺</span>
                <span className="text-sm md:text-base lg:text-lg font-bold text-white">
                  15,000+ YouTube learners
                </span>
              </div>
            </motion.div>
            
            
          </div>

          {/* Right side - Profile image */}
          <motion.div
            initial={{ opacity: 0, x: 80, scale: 1.3 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="flex justify-center items-end h-64 md:block md:col-span-1 lg:col-span-1 md:relative md:h-full"
          >
            {/* Mobile image */}
            <img 
              src="/images/profile.png" 
              alt="Mukesh Rathore" 
              className="block md:hidden absolute bottom-0 right-0 h-full w-auto object-contain object-bottom drop-shadow-2xl"
            />
            {/* Desktop image */}
            <img 
              src="/images/profile.png" 
              alt="Mukesh Rathore" 
              className="hidden md:block absolute bottom-0 right-0 drop-shadow-2xl"
              style={{ height: '80vh', width: 'auto', maxWidth: 'none' }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
